export default {
  title: 'Betalen met {{method}}',
  hint: 'Vervolgens bevestig je de betaling bij je bank of in je app.',
  continue: 'Doorgaan',
  cancel: 'Betaling annuleren',
  unavailable: 'Deze betaalmethode is momenteel niet beschikbaar. Kies een andere.',
};
